import { t as __t } from "i18next";
import { Link, useLocation } from "react-router-dom";
import { isActiveLink } from "../../utils/linkActiveChecker";
import { useDispatch, useSelector } from "react-redux";
import { menuToggle } from "../../features/toggle/toggleSlice";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { setData } from "../../redux/menuSlice";
import "./dashboard-shell-green.css";


// TEMP: Hard-coded Legacy Life Entry menu.
// Remove this block after the menu is configured through the normal permission/menu API.
const LEGACY_LIFE_ENTRY_MENU = {
	id: "hardcoded-legacy-life-entry",
	name: "legacyLifeEntry.title",
	icon: "la-file-contract",
	routePath: "/admin/legacyLifeEntry/list",
	children: [
		{
			id: "hardcoded-legacy-life-entry-create",
			name: "legacyLifeEntry.createContract",
			routePath: "/admin/legacyLifeEntry/save",
		},
		{
			id: "hardcoded-legacy-life-entry-bill",
			name: "legacyLifeEntry.billEntryTitle",
			routePath: "/admin/legacyLifeEntry/bill",
		},
		{
			id: "hardcoded-legacy-life-entry-list",
			name: "legacyLifeEntry.listTitle",
			routePath: "/admin/legacyLifeEntry/list",
		},
		{
			id: "hardcoded-legacy-life-entry-approval",
			name: "legacyLifeEntry.approvalListTitle",
			routePath: "/admin/legacyLifeEntry/approval",
		},
	],
};

const withLegacyLifeEntryMenu = (menu = []) => {
	const hasLegacyMenu = menu.some(
		(item) => item.id === LEGACY_LIFE_ENTRY_MENU.id || item.routePath?.startsWith("/admin/legacyLifeEntry")
	);

	return hasLegacyMenu ? menu : [...menu, LEGACY_LIFE_ENTRY_MENU];
};

const DashboardEmployerSidebar = () => {
	const { pathname } = useLocation();
	const { menu } = useSelector((state) => state.toggle);
	const { t } = useTranslation();
	const [dataMenu, setDataMenu] = useState([]);
	const [openMenu, setOpenMenu] = useState(null);
	const dispatch = useDispatch();

	useEffect(() => {
		const adminMenu = localStorage.getItem("adminMenu");

		try {
			const parsedMenu = adminMenu ? JSON.parse(adminMenu) : [];
			const menuWithLegacyEntry = withLegacyLifeEntryMenu(parsedMenu);
			setDataMenu(menuWithLegacyEntry);

			const parentMenu = menuWithLegacyEntry.find((item) =>
				item.children?.some((child) => isActiveLink(child.routePath, pathname))
			);
			if (parentMenu) setOpenMenu(parentMenu.id);

			const currentItem = menuWithLegacyEntry
				.flatMap((parent) => (parent.children?.length ? parent.children : [parent]))
				.find((item) => isActiveLink(item.routePath, pathname));
			console.log(currentItem)
			if (currentItem?.permissions) dispatch(setData(currentItem.permissions));
		} catch (error) {
			console.error("Invalid adminMenu data", error);
		}
	}, [pathname, dispatch]);

	const menuToggleHandler = () => dispatch(menuToggle());

	const handleLinkClick = (e, item) => {
		if (item.routePath !== "/logout") return;

		e.preventDefault();
		Swal.fire({
			title: t("areYouSure"),
			text: t("confirmLogout"),
			icon: "question",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#dc2626",
			confirmButtonText: t("confirm"),
			cancelButtonText: t("cancel"),
		}).then((result) => {
			if (result.isConfirmed) window.location.href = "/logout";
		});
	};

	const toggleSubMenu = (e, id) => {
		e.preventDefault();
		setOpenMenu((current) => (current === id ? null : id));
	};

	return (
		<aside className={`user-sidebar gwin-dashboard-sidebar ${menu ? "offcanvas offcanvas-start mobile_menu-contnet" : ""}`}>
			<div className="pro-header text-end pb-0 mb-0 show-1023 gwin-sidebar-mobile-close">
				<button type="button" className="gwin-sidebar-close-button" onClick={menuToggleHandler} aria-label={t("accessibility.closeNavigation")}>
					<span className="flaticon-close" />
				</button>
			</div>

			<div className="sidebar-inner gwin-sidebar-inner">
				<div className="gwin-sidebar-heading">
					<div className="gwin-sidebar-heading-icon"><i className="la la-th-large" /></div>
					<div>
						<span className="gwin-sidebar-eyebrow">{__t("uiText.text418")}</span>
						<strong className="gwin-sidebar-title">{__t("uiText.text012")}</strong>
					</div>
				</div>

				<ul className="navigation gwin-sidebar-navigation">
					{dataMenu?.map((item) => {
						const hasSubmenu = Boolean(item.children?.length);
						const isChildActive = hasSubmenu && item.children.some((child) => isActiveLink(child.routePath, pathname));
						const isSelfActive = isActiveLink(item.routePath, pathname);
						const isOpen = openMenu === item.id;
						const shouldSetActive = !hasSubmenu && isSelfActive;
						const parentHighlighted = isOpen || isChildActive;

						return (
							<li key={item.id} className={`gwin-nav-item ${shouldSetActive ? "active" : ""} ${parentHighlighted ? "is-open" : ""}`}>
								{hasSubmenu ? (
									<button
										type="button"
										className={`menu-link gwin-nav-link gwin-nav-parent ${parentHighlighted ? "active" : ""}`}
										onClick={(e) => toggleSubMenu(e, item.id)}
										aria-expanded={isOpen}
									>
										<span className="gwin-nav-main">
											<span className={`gwin-nav-icon`}><i className={`la ${item.icon}`} /></span>
											<span>{t(item.name)}</span>
										</span>
										<i className={`la la-angle-down gwin-nav-chevron ${isOpen ? "rotate-180" : ""}`} />
									</button>
								) : (
									<Link
										to={item.routePath || "#"}
										onClick={(e) => handleLinkClick(e, item)}
										className={`menu-link gwin-nav-link ${shouldSetActive ? "activeRoot" : ""}`}
									>
										<span className="gwin-nav-main">
											<span className={`gwin-nav-icon`}><i className={`la ${item.icon}`} /></span>
											<span>{t(item.name)}</span>
										</span>
									</Link>
								)}

								{hasSubmenu && (
									<ul className={`submenu gwin-submenu ${isOpen ? "d-block" : "d-none"}`}>
										{item.children.map((child) => {
											const isChildSelected = isActiveLink(child.routePath, pathname);
											return (
												<li key={child.id}>
													<Link
														to={child.routePath}
														onClick={(e) => handleLinkClick(e, child)}
														className={`gwin-submenu-link ${isChildSelected ? "submenuActive active" : ""}`}
													>
														<span className="gwin-submenu-dot" />
														{child.icon && <i className={child.icon} />}
														<span>{t(child.name)}</span>
													</Link>
												</li>
											);
										})}
									</ul>
								)}
							</li>
						);
					})}
				</ul>
			</div>
		</aside >
	);
};

export default DashboardEmployerSidebar;
